import { render, staticRenderFns } from "./VsmeBusiness.vue?vue&type=template&id=0190283b&scoped=true"
import script from "./VsmeBusiness.vue?vue&type=script&lang=js"
export * from "./VsmeBusiness.vue?vue&type=script&lang=js"
import style0 from "./VsmeBusiness.vue?vue&type=style&index=0&id=0190283b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0190283b",
  null
  
)

export default component.exports